/** 数据看板跳转：统一 group / fromGroup / groupName / range */

export const PLATFORM_SLUG = {
  xiaohongshu: 'xhs',
  xhs: 'xhs',
  douyin: 'douyin',
  zhihu: 'zhihu',
  toutiao: 'toutiao',
  baijiahao: 'baijiahao',
}

export const PLATFORM_LABEL = {
  xhs: '小红书',
  xiaohongshu: '小红书',
  douyin: '抖音',
  zhihu: '知乎',
  toutiao: '头条',
  baijiahao: '百家号',
}

export function resolveGroupId(query = {}) {
  return String(query.group || query.fromGroup || '').trim()
}

export function resolveGroupName(query = {}, groupId = '') {
  const name = String(query.groupName || '').trim()
  if (name) return name
  return groupId ? `分组 #${groupId}` : ''
}

export function platformSlug(platform) {
  return PLATFORM_SLUG[platform] || String(platform || '').trim()
}

export function platformLabel(platform) {
  return PLATFORM_LABEL[platform] || PLATFORM_LABEL[platformSlug(platform)] || '平台'
}

/**
 * 继承分组上下文，兼容 group / fromGroup。
 * @param {object} routeOrQuery route 或 query
 * @param {object} extra 覆盖项（如 range）
 */
export function inheritBoardQuery(routeOrQuery, extra = {}) {
  const q = routeOrQuery?.query ? { ...routeOrQuery.query } : { ...(routeOrQuery || {}) }
  const group = resolveGroupId({ ...q, ...extra })
  const groupName = String(extra.groupName ?? q.groupName ?? '').trim()
  const rangeRaw = extra.range != null && extra.range !== '' ? extra.range : q.range
  const out = { ...extra }
  delete out.groupName
  if (group) {
    out.group = group
    out.fromGroup = group
  }
  if (groupName) out.groupName = groupName
  if (rangeRaw != null && rangeRaw !== '') out.range = String(rangeRaw)
  return out
}

export function matrixGroupLink(groupId, range) {
  const query = {}
  if (range != null && range !== '') query.range = String(range)
  return { path: `/data-analytics/group/${groupId}`, query }
}

export function platformGroupLink(platform, groupId, range) {
  const slug = platformSlug(platform)
  const query = {}
  if (range != null && range !== '') query.range = String(range)
  return { path: `/data-analytics/${slug}/group/${groupId}`, query }
}

export function accountBoardLink(platform, accountId, routeOrQuery, extra = {}) {
  const slug = platformSlug(platform)
  return {
    path: `/data-analytics/${slug}/${encodeURIComponent(accountId)}`,
    query: inheritBoardQuery(routeOrQuery, extra),
  }
}

export function itemBoardLink(platform, accountId, itemId, routeOrQuery, extra = {}) {
  const slug = platformSlug(platform)
  const seg = slug === 'xhs' ? 'notes' : 'works'
  return {
    path: `/data-analytics/${slug}/${encodeURIComponent(accountId)}/${seg}/${encodeURIComponent(itemId)}`,
    query: inheritBoardQuery(routeOrQuery, extra),
  }
}
